import Phaser from 'phaser';
import { VIEW_HEIGHT, VIEW_WIDTH, RENDER_RESOLUTION_SCALE, WORLD_GRAVITY } from './config/gameplay';
import { MATTER_RUNNER_CONFIG } from './phaser/physics/fixedStep';
import { BootScene } from './phaser/scenes/BootScene';
import { GameScene } from './phaser/scenes/GameScene';
import { AppShell } from './ui/AppShell';
import './styles/main.css';
import './styles/side-menu.css';
import './styles/gacha.css';
import './styles/skins.css';
import './styles/ranking.css';
import './styles/profile.css';
import './styles/observer-video.css';
import './styles/modes.css';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Application root was not found');

new AppShell(root);

const renderWidth = VIEW_WIDTH * RENDER_RESOLUTION_SCALE;
const renderHeight = VIEW_HEIGHT * RENDER_RESOLUTION_SCALE;

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game-canvas',
  width: renderWidth,
  height: renderHeight,
  backgroundColor: 'rgba(0,0,0,0)',
  transparent: true,
  antialias: true,
  render: {
    powerPreference: 'high-performance',
    antialias: true,
    // Characters shrink from 1024px to small, rotating sprites. Sample
    // prefiltered mip levels to keep fine details from aliasing and shimmering.
    mipmapFilter: 'LINEAR_MIPMAP_LINEAR',
    roundPixels: false,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    // CSS owns the canvas rectangle; fitted margins would offset it from the rails.
    autoCenter: Phaser.Scale.NO_CENTER,
    width: renderWidth,
    height: renderHeight,
  },
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: WORLD_GRAVITY },
      enableSleeping: true,
      positionIterations: 8,
      velocityIterations: 6,
      constraintIterations: 2,
      runner: MATTER_RUNNER_CONFIG,
      debug: false,
    },
  },
  scene: [BootScene, GameScene],
});
